import { z } from "zod";
import { ConfidenceSchema, IdSchema, IsoTimestampSchema, NonEmptyStringSchema, PositiveIntegerSchema, SourceRefSchema } from "./source.js";
import { RequirementTagsSchema } from "./tags.js";
export const RequirementScopeSchema = z
    .object({
    level: z.enum([
        "project",
        "building",
        "apartment_type",
        "room",
        "device",
        "export"
    ]),
    refId: IdSchema.optional(),
    label: NonEmptyStringSchema.optional()
})
    .strict();
export const EdgeFeatureKindSchema = z.enum(["leak_detection", "metering_dashboard"]);
export const EdgeProvisionUnitSchema = z.enum(["per_apartment", "per_project"]);
export const EdgeInputPolicySchema = z.enum([
    "reuse_existing_titan_inputs",
    "dedicated_sensors_to_confirm",
    "dedicated_sensors_required"
]);
export const EdgeRequirementSchema = z
    .object({
    featureKind: EdgeFeatureKindSchema,
    provisionUnit: EdgeProvisionUnitSchema.optional(),
    inputPolicy: EdgeInputPolicySchema.optional(),
    requiresCloudDashboard: z.boolean().optional(),
    requiresSmsNotification: z.boolean().optional()
})
    .strict();
export const ThirdPartyIntegrationKindSchema = z.enum([
    "crestron",
    "third_party_av_home_automation"
]);
export const ThirdPartyIntegrationRequirementSchema = z
    .object({
    integrationKind: ThirdPartyIntegrationKindSchema,
    protocol: NonEmptyStringSchema.optional(),
    integratorName: NonEmptyStringSchema.optional(),
    commissioningDeliverableRequired: z.boolean().optional()
})
    .strict();
export const ProductQuantityRequirementSchema = z
    .object({
    productPartNo: NonEmptyStringSchema,
    quantity: PositiveIntegerSchema,
    provisionScope: z.enum(["apartment_type", "project"]),
    role: NonEmptyStringSchema.optional()
})
    .strict();
export const UiStrategySchema = z.enum([
    "per_room",
    "per_room_plus_central",
    "central_only"
]);
export const RequirementSchema = z
    .object({
    id: IdSchema,
    projectId: IdSchema,
    scope: RequirementScopeSchema,
    type: NonEmptyStringSchema,
    tags: RequirementTagsSchema,
    uiStrategy: UiStrategySchema.optional(),
    edgeFeature: EdgeRequirementSchema.optional(),
    thirdPartyIntegration: ThirdPartyIntegrationRequirementSchema.optional(),
    productQuantity: ProductQuantityRequirementSchema.optional(),
    interpretedText: NonEmptyStringSchema,
    priority: z.enum(["blocking", "default", "option", "rfi", "ve"]),
    sourceRefs: z.array(SourceRefSchema).min(1),
    policyFlagRefs: z.array(IdSchema).optional(),
    status: z.enum(["candidate", "approved", "rejected", "superseded"]),
    confidence: ConfidenceSchema,
    overrideState: z.enum([
        "none",
        "overridden",
        "superseded",
        "draft_override",
        "human_review_required"
    ]),
    interactsWith: z.array(IdSchema),
    canSubstituteFor: z.array(IdSchema),
    createdBy: z.enum(["agent", "human", "import"]),
    reviewedBy: NonEmptyStringSchema.optional(),
    createdAt: IsoTimestampSchema
})
    .strict();
export const RequirementEdgeKindSchema = z.enum([
    "overrides",
    "conflicts_with",
    "satisfies",
    "substitutes",
    "refines",
    "requires",
    "same_as"
]);
export const RequirementEdgeSchema = z
    .object({
    id: IdSchema,
    projectId: IdSchema,
    fromRequirementId: IdSchema,
    toRequirementId: IdSchema,
    kind: RequirementEdgeKindSchema,
    rationale: NonEmptyStringSchema,
    sourceRefs: z.array(SourceRefSchema).min(1),
    createdAt: IsoTimestampSchema
})
    .strict();
export const RequirementBaselineSchema = z
    .object({
    id: IdSchema,
    orgId: IdSchema,
    projectId: IdSchema,
    version: NonEmptyStringSchema,
    status: z.enum(["draft", "approved", "superseded"]),
    requirementIds: z.array(IdSchema),
    requirements: z.array(RequirementSchema),
    edges: z.array(RequirementEdgeSchema),
    unresolvedRfiIds: z.array(IdSchema),
    sourceRefs: z.array(SourceRefSchema).min(1),
    approvedAt: IsoTimestampSchema.optional(),
    createdAt: IsoTimestampSchema
})
    .strict();
//# sourceMappingURL=requirements.js.map